import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/__nuxt-public/images/icon_map.png")